<on-loading *ngIf="isLoading"></on-loading>
<div class="col m-2" *ngIf="!isLoading">
    <h3 class="einvoicing-title">
        <span>{{ 'company.einvoicing.title' | translate }}</span>
        <button
            nb-button
            class="btn btn-primary float-right"
            [nbTooltip]="'company.einvoicing.add' | translate"
            nbTooltipStatus="primary"
            (click)="openEntityModal()"
        >
            <nb-icon icon="fa-plus"></nb-icon>
            {{ 'company.einvoicing.add' | translate }}
        </button>
    </h3>
    <p class="text-muted">
        {{ 'company.einvoicing.description' | translate }}
    </p>
    <div class="alert alert-info">
        <nb-icon icon="fa-qrcode" class="mr-2"></nb-icon>
        {{ 'company.einvoicing.mobile-info' | translate }}
    </div>
</div>
<div
    *ngIf="!isLoading && entities.length === 0"
    class="col m-5"
    align="center"
>
    <h6>{{ 'company.einvoicing.no-entity' | translate }}</h6>
</div>
<div class="col m-2" *ngIf="!isLoading && entities.length > 0">
    <table class="table table-hover align-middle">
        <thead>
            <tr>
                <th>{{ 'company.einvoicing.name-label' | translate }}</th>
                <th>{{ 'company.einvoicing.siren-label' | translate }}</th>
                <th>{{ 'company.einvoicing.address-label' | translate }}</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let entity of entities">
                <td>{{ entity.Name }}</td>
                <td>{{ entity.Siren }}</td>
                <td>{{ entity.ElectronicInvoicingAddress }}</td>
                <td class="text-end">
                    <button
                        class="btn btn-sm btn-outline-primary"
                        (click)="openEntityModal(entity)"
                    >
                        <nb-icon icon="fa-edit"></nb-icon>
                        {{ 'company.einvoicing.edit' | translate }}
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>
